"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._EventList = {
    type: "list",
    flattened: true,
    member: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_EventList.js.map